import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { BrushHighlight } from './brushHighlight';
export function brushYRegion(x, y, x1, y1, extent) {
  var _extent = _slicedToArray(extent, 3),
    minX = _extent[0],
    maxX = _extent[2];
  return [minX, y, maxX, y1];
}
export function BrushYHighlight(options) {
  return BrushHighlight(Object.assign(Object.assign({}, options), {
    brushRegion: brushYRegion,
    selectedHandles: ['handle-n', 'handle-s']
  }));
}